import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import { FadeLoader } from "react-spinners";
import Sidebar from "./Sidebar";
import ChunkErrorBoundary from "../common/ChunkErrorBoundary";

const PrivateRoutesSuspense = ({ children }) => {
  const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(false);
  return (
    <>
      <div>
        <div className="main-wrap ">
          <div className={show ? "left-side hide" : "left-side "}>
            <Sidebar
              isActive={isActive}
              setIsActive={setIsActive}
              show={show}
              setShow={setShow}
            />
          </div>
          <div className="top-fix-sec">
            <ChunkErrorBoundary>
              <Suspense
                fallback={
                  <div className="loader-style container-fluid">
                    <FadeLoader
                      className="fade-loader"
                      loading={true}
                      color={"#D61F7F"}
                    />
                  </div>
                }
              >
                <div className={show ? "right-side-cmn hide" : "right-side-cmn "}>
                  {children || <Outlet />}
                </div>
              </Suspense>
            </ChunkErrorBoundary>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivateRoutesSuspense;
